<template>
  <Layout :removePadding="true" :onlyLogoHeader="true">
    <div class="d-flex flex-column" style="height: 100%;">
      <div class="flex-grow-1">
        <div
          style="color: var(--primary-color-blue);"
          class="text-center display font-weight-bold"
          :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
        >
          {{ $t("headers.sign_up_title") }}
          <p style="color: var(--primary-color-blue);" class="text-center font-weight-light subtitle-2 pt-2">
            {{ $t("headers.sign_up_type") }}
          </p>
        </div>
        <div class="mt-13 mx-10">
          <OptionButton
            v-for="(button, i) in optionButtons"
            v-if="button.active"
            :key="i"
            :icon="button.icon"
            :custom_icon="button.custom_icon"
            :label="button.text"
            class="mb-3"
            @click.native="
              $router.push({
                name: routeNames.VALIDATE_TAG_OR_TICKET,
                params: { type: button.type },
              })
            "
          />
        </div>
        <p style="color: var(--primary-color-blue); text-decoration: underline;" class="text-center pt-10 clickable" @click="$router.push({name: routeNames.SIGN_UP_NO_REFERENCE, params: { type: 'no_reference' }})">
          {{noReferenceMethodsText}}
        </p>
        <p style="color: var(--primary-color-blue);" class="text-center pt-2">
          {{ $t("headers.sign_up_already") }}
          <span
            style="text-decoration: underline;"
            class="font-weight-bold clickable"
            @click="$router.push({ name: routeNames.LOGIN })"
            >{{ $t("headers.sign_in") }}</span
          >
        </p>
      </div>
      <BottomBar :logged="false"/>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import routeNames from "@/router/route-names";
import OptionButton from "@/components/form-elements/BigButton";
import BottomBar from "@/components/BottomBar";

export default {
  name: "SignUpView",
  data() {
    return {
      link_array: [],
      routeNames: routeNames,
      optionButtons: {
        ticket: {
          icon: "confirmation_number",
          text: this.$t("sign_up_options.locator"),
          type: "locator",
          active: false,
        },
        tag: {
          custom_icon: "tag",
          icon: "watch",
          text: this.$t("sign_up_options.tag"),
          type: "tag",
          active: false,
        },
      },
    };
  },
  methods: {
    linkOptions() {
      this.link_array = this.$store.getters.customization.link_array;

      if (this.link_array.length == 1) {
        this.$router.push({
          name: routeNames.SIGN_UP,
          params: {
            type: this.optionButtons[this.link_array[0]].type,
            singleType: true,
          },
        });
      }

      this.link_array.map((element) => {
        if (element != "no_reference") {
          this.optionButtons[element].active = true;
        }
      });
      
    },
  },
  async created() {
    await this.linkOptions();
  },
  components: {
    Layout,
    OptionButton,
    BottomBar
  },
  computed: {
    noReferenceMethodsText() {
      if (["tag","ticket"].every(f => this.link_array.includes(f) )) {
        return this.$t("headers.do_not_have_code_or_tag")
      }if (this.link_array.includes("tag")) {
        return this.$t("headers.do_not_have_tag")        
      }if (this.link_array.includes("ticket")) {
        return this.$t("headers.do_not_have_code")                
      }
    }
  }
};
</script>
